module.exports = __webpack_public_path__ + "static/media/top-active-players-active-dark-icon.e58fe654.svg";